export default __webpack_public_path__ + "static/media/careers-hero.d97b8c58.png";